export default __webpack_public_path__ + "static/media/nuPLAN_logo_w.395cbdee.svg";